
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import ShowMoreText from "react-show-more-text";
import * as ReactDOM from 'react-router-dom'
import axios from "axios";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { Helmet } from "react-helmet";


const Group = () => {

    //#region Const 
    const navigate = ReactDOM.useNavigate();
    let { Id } = ReactDOM.useParams();
    let { Parent } = ReactDOM.useParams();
    const toaster = rsuite.useToaster();
    const [ProductGroupList, setProductGroupList] = React.useState([]);
    const [background, setbackground] = React.useState("");
    const [persianParent, setpersianParent] = React.useState("");





    const GetProductGroup = () => {
        fetch(General.ApiRoute() + '/ProductGroup/GetByIdForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'Id': Id,
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {

                const img = new Image();
                img.src = General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + result.photoId + '_Img.jpg';

                if (img.complete) {
                    setbackground(General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + result.photoId + '_Img.jpg')
                } else {
                    img.onload = () => {
                        setbackground(General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.photoTag + '' + result.photoId + '_Img.jpg')
                    };

                    img.onerror = () => {
                        setbackground('')
                    };
                }


                var tmp = []
                var checkingLen = isMobile ? 15 : 20;
                document.title = result.title;
                setpersianParent(result.title)
                for (var i = 0; i < result.children.length; i++) {
                    tmp.push({
                        id: result.children[i].id,
                        title: result.children[i].title,
                        isActive: result.children[i].isActive,
                        webIsActive: result.children[i].webIsActive,
                        parentId: result.children[i].parentId,
                        photoTag: result.children[i].photoTag,
                        PhotoUrl: General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result.children[i].photoTag + '' + result.children[i].photoId + '_Img.jpg',


                    })
                }
                console.dir(tmp)
                setProductGroupList(tmp)


            })
    }

    const NavigatePage = (url, innerGroup, groupId) => {
        // navigate(url)
        if (url == "/")
            window.location.href = url;
        else {
            var group = General.toSlug(innerGroup, { latin: true });
            var NewGroup = group != Parent ? group.replace(Parent, "").replace(/-+/g, "-").replace(/^-+|-+$/g, "") : group;

            window.location.href = url + "/" + Parent + "/" + NewGroup + "/" + Id + "/" + groupId;
        }

    }

    //#endregion
    React.useEffect(() => {
        GetProductGroup();
        localStorage.removeItem("ByBrand");
        localStorage.removeItem("ProductId");
    }, [])


    return (
        <Layout>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                <meta
                    name="description"
                    content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                />
            </Helmet >
            <div className={isBrowser ? 'InnerBanner' : "InnerBanner_MobView"}
                style={{
                    backgroundImage: `url(${background})`
                    , background: `linear-gradient(90deg, rgba(47,72,88,1) 0%, rgba(76,114,139,1) 27%, rgba(251,250,250,1) 67%)`
                }}
            >
            </div>
            <h1 className={isBrowser ? "InnerBanner-text " : "InnerBanner-text_MobView"}> {persianParent}
            </h1>
            <h1 className="ProductInfoAddressBar ">
                <rsuite.Breadcrumb>
                    <rsuite.Breadcrumb.Item onClick={() => NavigatePage("/")}>
                        خانه
                    </rsuite.Breadcrumb.Item>

                    <rsuite.Breadcrumb.Item style={{ color: '#3b6682' }}>{persianParent}</rsuite.Breadcrumb.Item>
                </rsuite.Breadcrumb>
            </h1>
            <rsuite.Grid className="pt-3">



                <rsuite.Row className="justify-content-center align-items-center pt-5">

                    {ProductGroupList.map((group) =>

                        <rsuite.Col xs={24} sm={12} md={8} lg={6} className="pb-4">




                            <rsuite.Panel onClick={() => NavigatePage('/Product', group.title, group.id)} className='shadow-sm  Selective' bodyFill style={{ display: 'inline-block', width: '100%' }}>

                                <rsuite.Image
                                    src={group.PhotoUrl}
                                    fallbackSrc="../../assets/images/ProductGroupPrefer.jpg"
                                    alt={group.title}
                                    placeholder={<img src="../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '180px' }} />}
                                    zoomed

                                    style={{ width: '100%', height: '180px' }}
                                />

                                <rsuite.Panel >
                                    <p className="text-truncate Font13 fw-bold" >
                                        {group.title}
                                    </p>

                                </rsuite.Panel>

                            </rsuite.Panel>

                        </rsuite.Col>
                    )}
                </rsuite.Row>
            </rsuite.Grid>


        </Layout >
    )
}

export default Group;